import { AuthConfig } from 'angular-oauth2-oidc';

import { environment } from '@ca/environment/environment';

export const authConfig: AuthConfig = {
    // URL of the Identity Provider.
    issuer: environment.authIssuerUrl,

    // URL of the SPA to redirect the user to after login.
    redirectUri: environment.baseUrl + '/?',

    // URL of the SPA to redirect the user after silent refresh.
    silentRefreshRedirectUri: environment.baseUrl + '/assets/misc/silent-refresh.html',

    postLogoutRedirectUri: window.location.origin,
    // The SPA's id. The SPA is registered with this id at the auth-server.
    clientId: 'frontend',

    // Set the scope for the permissions the client should request.
    scope:
        // eslint-disable-next-line
        'openid profile zeissid api1 ai_registry ai_registry.proxy documents modules device_hub module_builder customer_support workflow_run notifications role userinfo user_service tagging_service czi_service zeissid_proxy_service segment_anything_service virus_scan_service',

    responseType: 'id_token token',

    // TODO: Should be through SSL in the future. At the moment doesn't work with HTTPS.
    requireHttps: false,

    // Activate session checks - the library automatically ends local session when logging out.
    sessionChecksEnabled: false,

    showDebugInformation: false,

    timeoutFactor: 0.9,

    clearHashAfterLogin: false,
};
